// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sub-Client-form {
  display: grid;
  grid-template-columns: 40% 40% auto;
  column-gap: 3.5vw;
  row-gap: 1.6vw;
  /* gap:10px */
}

.sub-Client-form::-webkit-scrollbar {
  display: none;
}

.Field {
  display: flex;
  flex-direction: column;
  row-gap: 0.75vw;
}

.Field-label {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 0.9vw;
  color: #808080;
  white-space: nowrap;
}

.hide {
  visibility: hidden;
}
.errorline {
  color: #e77b7b;
  font-size: 0.9vw;
  font-family: Poppins;
  width: 100%;
}
.Field-input {
  height: 2.5vw;
  width: 100%;
  background-color: transparent;
  border: 0.5px solid #ffffff;
  color: white;
  font-family: "Karla";
  font-weight: 400;
  font-size: 0.9vw;
  line-height: 1.1vw;
  letter-spacing: -0.41px;
  padding: 0 0.8vw;
  transition: all 0.3s ease-in-out;
  border-radius: 0.25vw;

  &:focus {
    outline: 0;
  }
}

.Field-occupy {
  grid-column: 1/4;
}

.field-sub {
  display: flex;
  align-items: center;
  column-gap: 0.8vw;
}

.Field-input + span {
  height: 1.3vw;
  width: 1.3vw;
  cursor: pointer;
}

/* .field-sub:last-child{
    border:"0.5px solid white";
} */

.btn-container {
  margin: 6vw 0 1vw 0;
  display: flex;
  justify-content: center;
}

.order-btn {
  height: 3.15vw;
  width: 14.75vw;
  font-family: "Poppins";
  font-weight: 500;
  font-size: 1vw;
  margin: 0px auto;
  border: none;
  border-radius: 0.25vw;
  transition: all 0.3s ease-in-out;
}

.order-btn-success {
  background-color: #50c878;
  cursor: pointer;
  text-transform: capitalize;
}

.order-btn-disable {
  background-color: #444444;
  /* cursor: not-allowed; */
  color: #000000;
  text-transform: capitalize;
}

.popper-top {
  margin-top: 1.5vw;
}

/* .Field-input .MuiOutlinedInput-root {
  height: 50px;
  background-color: transparent;
  border-radius: 5px;
  border: 0.5px solid #FFFFFF;
  color: white;
  font-family: "Karla";
  font-weight: 400;
  font-size: 18px;
  letter-spacing: -0.41px;
}

.Field-input .MuiOutlinedInput-input {
  padding: 0 14px;
  height: 50px;
}

.Field-input .MuiOutlinedInput-notchedOutline {
  border: none;
}

.Field-input .Mui-focused .MuiOutlinedInput-notchedOutline {
  border: 0.5px solid #FFFFFF;
} */
`, "",{"version":3,"sources":["webpack://./src/features/order_client_details/client-Details-Style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;;EAErB;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;GAuBG","sourcesContent":[".sub-Client-form {\n  display: grid;\n  grid-template-columns: 40% 40% auto;\n  column-gap: 3.5vw;\n  row-gap: 1.6vw;\n  /* gap:10px */\n}\n\n.sub-Client-form::-webkit-scrollbar {\n  display: none;\n}\n\n.Field {\n  display: flex;\n  flex-direction: column;\n  row-gap: 0.75vw;\n}\n\n.Field-label {\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 0.9vw;\n  color: #808080;\n  white-space: nowrap;\n}\n\n.hide {\n  visibility: hidden;\n}\n.errorline {\n  color: #e77b7b;\n  font-size: 0.9vw;\n  font-family: Poppins;\n  width: 100%;\n}\n.Field-input {\n  height: 2.5vw;\n  width: 100%;\n  background-color: transparent;\n  border: 0.5px solid #ffffff;\n  color: white;\n  font-family: \"Karla\";\n  font-weight: 400;\n  font-size: 0.9vw;\n  line-height: 1.1vw;\n  letter-spacing: -0.41px;\n  padding: 0 0.8vw;\n  transition: all 0.3s ease-in-out;\n  border-radius: 0.25vw;\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n.Field-occupy {\n  grid-column: 1/4;\n}\n\n.field-sub {\n  display: flex;\n  align-items: center;\n  column-gap: 0.8vw;\n}\n\n.Field-input + span {\n  height: 1.3vw;\n  width: 1.3vw;\n  cursor: pointer;\n}\n\n/* .field-sub:last-child{\n    border:\"0.5px solid white\";\n} */\n\n.btn-container {\n  margin: 6vw 0 1vw 0;\n  display: flex;\n  justify-content: center;\n}\n\n.order-btn {\n  height: 3.15vw;\n  width: 14.75vw;\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 1vw;\n  margin: 0px auto;\n  border: none;\n  border-radius: 0.25vw;\n  transition: all 0.3s ease-in-out;\n}\n\n.order-btn-success {\n  background-color: #50c878;\n  cursor: pointer;\n  text-transform: capitalize;\n}\n\n.order-btn-disable {\n  background-color: #444444;\n  /* cursor: not-allowed; */\n  color: #000000;\n  text-transform: capitalize;\n}\n\n.popper-top {\n  margin-top: 1.5vw;\n}\n\n/* .Field-input .MuiOutlinedInput-root {\n  height: 50px;\n  background-color: transparent;\n  border-radius: 5px;\n  border: 0.5px solid #FFFFFF;\n  color: white;\n  font-family: \"Karla\";\n  font-weight: 400;\n  font-size: 18px;\n  letter-spacing: -0.41px;\n}\n\n.Field-input .MuiOutlinedInput-input {\n  padding: 0 14px;\n  height: 50px;\n}\n\n.Field-input .MuiOutlinedInput-notchedOutline {\n  border: none;\n}\n\n.Field-input .Mui-focused .MuiOutlinedInput-notchedOutline {\n  border: 0.5px solid #FFFFFF;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
